const init = { totalCount: 0, centers: [] };

const center = (state = init, action) => {
  switch (action.type) {
    case "CENTER":
      return action.center;
    default:
      return state;
  }
};

export default center;
